module.exports = __webpack_public_path__ + "img/emoji_47.9a824723.png";